var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = (_vm.info.amount / 100).toFixed(2)
  var m0 =
    _vm.info.haveDisCount === 1
      ? Number((_vm.info.disCountMoney / 100).toFixed(2))
      : null
  var m1 = String(_vm.info.duration)
  var l0 = _vm.__map(_vm.info.memberRidesResponseList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var g1 = item.rideStartTime.substring(5, 10)
    var g2 = item.rideEndTime.substring(5, 10)
    var g3 = g1 === g2 ? item.rideStartTime.substring(5, 10) : null
    var g4 = g1 === g2 ? item.rideStartTime.substring(11, 16) : null
    var g5 = g1 === g2 ? item.rideEndTime.substring(11, 16) : null
    var g6 = !(g1 === g2) ? item.rideStartTime.substring(5, 10) : null
    var g7 = !(g1 === g2) ? item.rideStartTime.substring(11, 16) : null
    var g8 = !(g1 === g2) ? item.rideEndTime.substring(5, 10) : null
    var g9 = !(g1 === g2) ? item.rideEndTime.substring(11, 16) : null
    return {
      $orig: $orig,
      g1: g1,
      g2: g2,
      g3: g3,
      g4: g4,
      g5: g5,
      g6: g6,
      g7: g7,
      g8: g8,
      g9: g9,
    }
  })
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        m0: m0,
        m1: m1,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }